import * as React from "react";

function Delete2(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 18" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.05.938h-.048c-.38 0-.7 0-.968.024a2.05 2.05 0 00-.801.217c-.101.053-.197.115-.287.185a2.05 2.05 0 00-.53.639c-.133.233-.267.525-.424.87l-.314.69H1.25a.563.563 0 000 1.124h.595l.424 7.02c.056.938.101 1.682.195 2.277.095.61.25 1.117.558 1.561.283.407.647.75 1.07 1.008.64.391 1.398.481 2.392.51a.563.563 0 00.032-1.125c-.984-.028-1.473-.122-1.839-.345a2.44 2.44 0 01-.731-.69c-.173-.248-.288-.568-.371-1.094-.084-.535-.126-1.226-.185-2.2l-.418-6.921h10.055l-.265 4.282a.563.563 0 001.123.07l.269-4.352h.596a.562.562 0 100-1.125h-3.356l-.368-.76a11.357 11.357 0 00-.433-.84 2.05 2.05 0 00-.53-.616 2.064 2.064 0 00-.284-.178 2.05 2.05 0 00-.785-.208A11.35 11.35 0 008.05.938zm2.094 2.625h-4.23l.092-.201c.17-.373.282-.619.387-.801.099-.174.17-.253.237-.305a.938.938 0 01.13-.084c.076-.04.177-.072.376-.09.21-.019.48-.02.89-.02.4 0 .663.001.868.02.194.017.293.047.367.086.045.023.088.05.129.08.067.05.138.126.238.294.106.176.221.412.396.772l.12.248z"
        fill="#E4002B"
      />
      <path
        d="M14.398 11.648a.563.563 0 00-.796-.796l-2.227 2.227-2.227-2.226a.562.562 0 10-.796.795l2.227 2.227-2.227 2.227a.563.563 0 10.796.795l2.227-2.226 2.227 2.227a.563.563 0 00.796-.796l-2.228-2.227 2.228-2.227z"
        fill="#E4002B"
      />
    </svg>
  );
}

export default Delete2;
